export default "__VITE_ASSET__KiQrKXDS__"